import { Component } from '@angular/core';

@Component({
  selector: 'hbo-scan-list',
  templateUrl: './scan-list.component.html',
  styleUrls: ['./scan-list.component.scss']
})
export class ScanListComponent {

}
